// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__eI5Ks","content":"RecentSearches_content__Wjs9T"};